// Copesa test PDF - 48 pages, local dev-content-files
// Filenames preserve original format: {page}_v1_{width}_{height}_{color}.jpg
// PdfPageImg.vue parses dimensions and color from the filename.

const BASE = '/dev-content-files/pdf/copesa';

export default [
    {
        large: `${BASE}/large/1_v1_2684_3711_e3dcdd.jpg`,
        thumb: `${BASE}/thumb/1_v1_370_512_e2dbdc.jpg`,
        text_layer: `${BASE}/text-layer/1.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/2_v1_2684_3711_d3d2d4.jpg`,
        thumb: `${BASE}/thumb/2_v1_370_512_d2d1d3.jpg`,
        text_layer: `${BASE}/text-layer/2.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/3_v1_2684_3711_dbdadc.jpg`,
        thumb: `${BASE}/thumb/3_v1_370_512_dbdadc.jpg`,
        text_layer: `${BASE}/text-layer/3.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/4_v1_2684_3711_ececec.jpg`,
        thumb: `${BASE}/thumb/4_v1_370_512_ebebeb.jpg`,
        text_layer: `${BASE}/text-layer/4.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/5_v1_2684_3711_d0d1d2.jpg`,
        thumb: `${BASE}/thumb/5_v1_370_512_d0d0d1.jpg`,
        text_layer: `${BASE}/text-layer/5.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/6_v1_2684_3711_f3cfd3.jpg`,
        thumb: `${BASE}/thumb/6_v1_370_512_f3cfd2.jpg`,
        text_layer: `${BASE}/text-layer/6.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/7_v1_2684_3711_c3cfd5.jpg`,
        thumb: `${BASE}/thumb/7_v1_370_512_c3cfd5.jpg`,
        text_layer: `${BASE}/text-layer/7.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/8_v1_2684_3711_f3f0f0.jpg`,
        thumb: `${BASE}/thumb/8_v1_370_512_f2efef.jpg`,
        text_layer: `${BASE}/text-layer/8.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/9_v1_2684_3711_e8e0e1.jpg`,
        thumb: `${BASE}/thumb/9_v1_370_512_e8e0e0.jpg`,
        text_layer: `${BASE}/text-layer/9.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/10_v1_2684_3711_d9d8d7.jpg`,
        thumb: `${BASE}/thumb/10_v1_370_512_d9d8d6.jpg`,
        text_layer: `${BASE}/text-layer/10.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/11_v1_2684_3711_b7987d.jpg`,
        thumb: `${BASE}/thumb/11_v1_370_512_b7977c.jpg`,
        text_layer: `${BASE}/text-layer/11.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/12_v1_2684_3711_dad8d7.jpg`,
        thumb: `${BASE}/thumb/12_v1_370_512_d9d8d6.jpg`,
        text_layer: `${BASE}/text-layer/12.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/13_v1_2684_3711_d9d8d9.jpg`,
        thumb: `${BASE}/thumb/13_v1_370_512_d8d7d9.jpg`,
        text_layer: `${BASE}/text-layer/13.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/14_v1_2684_3711_ebeaea.jpg`,
        thumb: `${BASE}/thumb/14_v1_370_512_eae9e9.jpg`,
        text_layer: `${BASE}/text-layer/14.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/15_v1_2684_3711_ecebec.jpg`,
        thumb: `${BASE}/thumb/15_v1_370_512_ebeaeb.jpg`,
        text_layer: `${BASE}/text-layer/15.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/16_v1_2684_3711_dadbdc.jpg`,
        thumb: `${BASE}/thumb/16_v1_370_512_d9dadb.jpg`,
        text_layer: `${BASE}/text-layer/16.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/17_v1_2684_3711_b6b4c0.jpg`,
        thumb: `${BASE}/thumb/17_v1_370_512_b5b3bf.jpg`,
        text_layer: `${BASE}/text-layer/17.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/18_v1_2684_3711_c6c1c1.jpg`,
        thumb: `${BASE}/thumb/18_v1_370_512_c5c0c0.jpg`,
        text_layer: `${BASE}/text-layer/18.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/19_v1_2684_3711_c2cec6.jpg`,
        thumb: `${BASE}/thumb/19_v1_370_512_c2cdc5.jpg`,
        text_layer: `${BASE}/text-layer/19.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/20_v1_2684_3711_dbd4cb.jpg`,
        thumb: `${BASE}/thumb/20_v1_370_512_dad3ca.jpg`,
        text_layer: `${BASE}/text-layer/20.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/21_v1_2684_3711_d0c2b7.jpg`,
        thumb: `${BASE}/thumb/21_v1_370_512_d0c1b6.jpg`,
        text_layer: `${BASE}/text-layer/21.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/22_v1_2684_3711_ceccce.jpg`,
        thumb: `${BASE}/thumb/22_v1_370_512_cecbcd.jpg`,
        text_layer: `${BASE}/text-layer/22.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/23_v1_2684_3711_e8e7e7.jpg`,
        thumb: `${BASE}/thumb/23_v1_370_512_e7e6e6.jpg`,
        text_layer: `${BASE}/text-layer/23.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/24_v1_2684_3711_d5d2d2.jpg`,
        thumb: `${BASE}/thumb/24_v1_370_512_d4d1d2.jpg`,
        text_layer: `${BASE}/text-layer/24.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/25_v1_2684_3711_ebeaea.jpg`,
        thumb: `${BASE}/thumb/25_v1_370_512_e9e9e9.jpg`,
        text_layer: `${BASE}/text-layer/25.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/26_v1_2684_3711_d9d8d9.jpg`,
        thumb: `${BASE}/thumb/26_v1_370_512_d8d7d8.jpg`,
        text_layer: `${BASE}/text-layer/26.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/27_v1_2684_3711_a9a5a8.jpg`,
        thumb: `${BASE}/thumb/27_v1_370_512_a9a5a8.jpg`,
        text_layer: `${BASE}/text-layer/27.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/28_v1_2684_3711_918aa2.jpg`,
        thumb: `${BASE}/thumb/28_v1_370_512_9189a1.jpg`,
        text_layer: `${BASE}/text-layer/28.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/29_v1_2684_3711_dfe0e0.jpg`,
        thumb: `${BASE}/thumb/29_v1_370_512_dedfe0.jpg`,
        text_layer: `${BASE}/text-layer/29.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/30_v1_2684_3711_d2cfce.jpg`,
        thumb: `${BASE}/thumb/30_v1_370_512_d1cecd.jpg`,
        text_layer: `${BASE}/text-layer/30.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/31_v1_2684_3711_d4d2d4.jpg`,
        thumb: `${BASE}/thumb/31_v1_370_512_d3d2d3.jpg`,
        text_layer: `${BASE}/text-layer/31.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/32_v1_2684_3711_ededed.jpg`,
        thumb: `${BASE}/thumb/32_v1_370_512_ececec.jpg`,
        text_layer: `${BASE}/text-layer/32.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/33_v1_2684_3711_c8cace.jpg`,
        thumb: `${BASE}/thumb/33_v1_370_512_c8c9ce.jpg`,
        text_layer: `${BASE}/text-layer/33.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/34_v1_2684_3711_dedcda.jpg`,
        thumb: `${BASE}/thumb/34_v1_370_512_dddbd9.jpg`,
        text_layer: `${BASE}/text-layer/34.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/35_v1_2684_3711_dcdcdd.jpg`,
        thumb: `${BASE}/thumb/35_v1_370_512_dbdcdc.jpg`,
        text_layer: `${BASE}/text-layer/35.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/36_v1_2684_3711_85878b.jpg`,
        thumb: `${BASE}/thumb/36_v1_370_512_84868b.jpg`,
        text_layer: `${BASE}/text-layer/36.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/37_v1_2684_3711_d2cbcf.jpg`,
        thumb: `${BASE}/thumb/37_v1_370_512_d1cace.jpg`,
        text_layer: `${BASE}/text-layer/37.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/38_v1_2684_3711_e3e2e4.jpg`,
        thumb: `${BASE}/thumb/38_v1_370_512_e2e2e3.jpg`,
        text_layer: `${BASE}/text-layer/38.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/39_v1_2684_3711_d3d0cf.jpg`,
        thumb: `${BASE}/thumb/39_v1_370_512_d3d0ce.jpg`,
        text_layer: `${BASE}/text-layer/39.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/40_v1_2684_3711_eae6e3.jpg`,
        thumb: `${BASE}/thumb/40_v1_370_512_e9e5e3.jpg`,
        text_layer: `${BASE}/text-layer/40.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/41_v1_2684_3711_dbd6d8.jpg`,
        thumb: `${BASE}/thumb/41_v1_370_512_dbd5d7.jpg`,
        text_layer: `${BASE}/text-layer/41.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/42_v1_2684_3711_bdbebf.jpg`,
        thumb: `${BASE}/thumb/42_v1_370_512_bcbdbe.jpg`,
        text_layer: `${BASE}/text-layer/42.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/43_v1_2684_3711_e7dce1.jpg`,
        thumb: `${BASE}/thumb/43_v1_370_512_e7dbe1.jpg`,
        text_layer: `${BASE}/text-layer/43.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/44_v1_2684_3711_d6d4d5.jpg`,
        thumb: `${BASE}/thumb/44_v1_370_512_d6d3d4.jpg`,
        text_layer: `${BASE}/text-layer/44.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/45_v1_2684_3711_e4e3dd.jpg`,
        thumb: `${BASE}/thumb/45_v1_370_512_e3e2dc.jpg`,
        text_layer: `${BASE}/text-layer/45.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/46_v1_2684_3711_bebfbe.jpg`,
        thumb: `${BASE}/thumb/46_v1_370_512_bdbfbd.jpg`,
        text_layer: `${BASE}/text-layer/46.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/47_v1_2684_3711_e9e9e9.jpg`,
        thumb: `${BASE}/thumb/47_v1_370_512_e8e8e8.jpg`,
        text_layer: `${BASE}/text-layer/47.html`,
        annotation_layer: null,
    },
    {
        large: `${BASE}/large/48_v1_2684_3711_dbd7d8.jpg`,
        thumb: `${BASE}/thumb/48_v1_370_512_dad6d7.jpg`,
        text_layer: `${BASE}/text-layer/48.html`,
        annotation_layer: null,
    },
];
